import { render, staticRenderFns } from "./ModattaFeatured.vue?vue&type=template&id=5c09c9de"
import script from "./ModattaFeatured.vue?vue&type=script&lang=js"
export * from "./ModattaFeatured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports